import { render, staticRenderFns } from "./EventDetailItem3.vue?vue&type=template&id=5bff15bb"
import script from "./EventDetailItem3.vue?vue&type=script&lang=ts"
export * from "./EventDetailItem3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports